"use client";
import { Control, UseFormClearErrors } from "react-hook-form";
import { IconScan } from "@tabler/icons-react";
import NewSelectInput from "../../../components/NewSelectInput";
import NewinputField from "../../../components/NewInput";
import { useMerchantAllListData } from "../../../apis/merchantApis";
import { useLanguage } from "../../../context/LanguageContext";

const invoiceTypes = [
  { value: "Bulk Scan", text: "Bulk Scan" },
  { value: "COD Invoice", text: "COD Invoice" },
  { value: "Payable Invoice", text: "Payable Invoice" },
];

const paymentTypes = [
  { value: "CC", text: "CC" },
  { value: "COD", text: "COD" },
  { value: "BOTH", text: "BOTH" },
];

type Props = {
  register: any;
  setValue: any;
  watch: any;
  errors: any;
  clearErrors?: UseFormClearErrors<any>;
  control: Control<any>; // ✅ Add this
  reset?: any;
  setSelectedOrders: React.Dispatch<React.SetStateAction<string[]>>;
  selectedOrders: string[];
};

const GenerateInvoice = ({
  register,
  errors,
  setValue,
  watch,
  control,
  reset,
  clearErrors,
  selectedOrders,
  setSelectedOrders,
}: Props) => {
  const { t } = useLanguage();
  const { data: clients } = useMerchantAllListData();

  const translatedInvoiceTypes = invoiceTypes.map((type) => ({
    ...type,
    text: t(type.text),
  }));

  const translatedPaymentTypes = paymentTypes.map((type) => ({
    ...type,
    text: t(type.text),
  }));

  return (
    <div className="w-full py-4 px-6 space-y-4 bg-gradient-to-tr from-[#FDF8E5] to-[#FAF8EC] rounded-2xl border border-[#ECECEC] shadow-sm">
      <div className="max-h-[350px] overflow-y-auto space-y-4">
        <div className="grid grid-cols-6 gap-4">
          <p className="text-[#212121]/80 col-span-6 uppercase text-sm font-medium">
            {t("Select Information")}
          </p>
          {/* Invoice Type Selector */}
          <NewSelectInput
            label={t("Select Invoices Type")}
            className="col-span-2"
            name="invoiceType"
            value={watch("invoiceType")}
            onChange={(val) => {
              setValue("invoiceType", val);
            }}
            selectOptions={translatedInvoiceTypes}
          />

          <NewSelectInput
            label={t("Select Client")}
            className="col-span-2"
            name="clientId"
            value={watch("clientId")}
            register={register}
            error={errors?.clientId}
            validation={{ required: t("Please select Client") }}
            onChange={(val) => {
              setValue("clientId", val);
            }}
            selectOptions={
              clients?.map((client: any) => ({
                id: client?.id,
                value: client?.id,
                text: client?.name,
              })) || []
            }
          />

          <NewSelectInput
            className="col-span-2"
            label={t("Select PaymentType")}
            name="paymentTypes"
            value={watch("paymentType")}
            onChange={(val) => {
              setValue("paymentType", val);
            }}
            selectOptions={translatedPaymentTypes}
          />

          {/* Bulk Scan Fields */}
          {watch("invoiceType") === "Bulk Scan" && (
            <div className="col-span-6 space-y-2">
              <div className="flex justify-between items-center ">
                <h2 className="text-[#212121] text-base font-medium">
                  {t("Shipments list")}
                </h2>
                <button className="rounded-full flex items-center gap-1 px-4 py-1 text-center bg-[#FBD037]/20 border border-[#FBD037] ">
                  <IconScan /> {t("Scan")}
                </button>
              </div>
              <div className="bg-[#FCFDF8] border border-[#D2D2D2] rounded-3xl p-8 flex flex-col items-center">
                <img src="/img/scan-data.png" alt="scan prompt" />
                <div className="text-center">
                  <h2 className="text-[#212121] text-lg font-medium">
                    {t("Scan to add")}
                  </h2>
                  <h2 className="text-[#212121]/70 text-sm">
                    {t("Scan shipment assign orders")}
                  </h2>
                </div>
              </div>
            </div>
          )}

          {/* COD Invoice or Payable Invoice Fields */}
          {(watch("invoiceType") === "COD Invoice" ||
            watch("invoiceType") === "Payable Invoice") && (
            <>
              <NewinputField
                className="col-span-3"
                name="entryDate"
                title={t("Entry Date")}
                placeholder="4 Aug 2025 - 10 Aug 2025"
                register={register}
                error={errors?.entryDate}
                validation={{ required: t("Entry Date is required") }}
                type="date"
              />
              <NewinputField
                className="col-span-3"
                name="closeDate"
                title={t("Close Date")}
                placeholder="4 Aug 2025 - 10 Aug 2025"
                register={register}
                error={errors?.closeDate}
                validation={{ required: t("Close Date is required") }}
                type="date"
              />
            </>
          )}
        </div>
      </div>
    </div>
  );
};

export default GenerateInvoice;
